import MainNavigation from "../../components/Navigation/MainNavigation";
import SectionNine from "./SectionNine";
import React from "react";



function Terms() {
    const [hover, setHover] = React.useState(false);
  return (
      <><><MainNavigation /><div style={styles.page}>

          <div style={styles.container}>
              <div style={styles.card}>
                  {/* Header */}
                  <div style={styles.header}>
                      <p style={styles.updated}>Last updated on 19/01/2025</p>
                      <h1 style={styles.title}>Terms and Conditions</h1>
                      <p style={styles.effective}>Effective Date: 2/12/2024</p>

                      <p style={styles.intro}>
                          Welcome to DataUp Gaming. By accessing or using our platform,
                          you agree to comply with and be bound by the following terms
                          and conditions. Please read them carefully before using our
                          services. If you do not agree to these terms, you should not
                          use our platform.
                      </p>
                  </div>

                  {/* Sections */}
                  <Section title="1. Acceptance of Terms">
                      By creating an account or accessing any services provided by
                      DataUp Gaming, you agree to abide by these Terms and Conditions,
                      as well as any updates or modifications made periodically.
                      Continued use of the platform signifies your acceptance of
                      these changes.
                  </Section>

                  <Section title="2. Eligibility">
                      You must be at least 13 years old, or the legal age of majority
                      in your jurisdiction, to use our services. By using the platform,
                      you represent and warrant that you meet these requirements.
                  </Section>

                  <Section title="3. Account Responsibilities">
                      <ul style={styles.list}>
                          <li style={styles.listItem}>
                              You are responsible for maintaining the confidentiality of your
                              account credentials and for all activities conducted under your account.
                          </li>
                          <li style={styles.listItem}>
                              You agree to notify us immediately if you suspect any unauthorized
                              use or breach of security.
                          </li>
                          <li style={styles.listItem}>
                              DataUp Gaming reserves the right to suspend or terminate accounts
                              suspected of fraudulent or harmful activities.
                          </li>
                      </ul>
                  </Section>

                  <Section title="4. Prohibited Conduct">
                      <ul style={styles.list}>
                          <li style={styles.listItem}>
                              Engaging in illegal activities or fraudulent purposes.
                          </li>
                          <li style={styles.listItem}>
                              Exploiting, hacking, or breaching platform security.
                          </li>
                          <li style={styles.listItem}>
                              Distributing harmful content including malware.
                          </li>
                          <li style={styles.listItem}>
                              Violating intellectual property rights.
                          </li>
                      </ul>
                  </Section>

                  <Section title="5. Payments and Transactions">
                      <ul style={styles.list}>
                          <li style={styles.listItem}>
                              All payments are subject to applicable fees communicated during transactions.
                          </li>
                          <li style={styles.listItem}>
                              Refunds are evaluated case-by-case.
                          </li>
                          <li style={styles.listItem}>
                              DataUp Gaming is not responsible for third-party payment processor issues.
                          </li>
                      </ul>
                  </Section>

                  <Section title="6. Intellectual Property">
                      All content, trademarks, designs, and materials on the platform
                      are owned by or licensed to DataUp Gaming. Unauthorized use is prohibited.
                  </Section>

                  <Section title="7. Privacy">
                      Your use of the platform is subject to our Privacy Policy.
                  </Section>

                  <Section title="8. Service Modifications">
                      DataUp Gaming reserves the right to modify, suspend, or discontinue
                      any part of the platform without prior notice.
                  </Section>

                  <Section title="9. Third-Party Links and Services">
                      We are not responsible for the content or practices of third-party services.
                  </Section>

                  <Section title="10. Disclaimer of Warranties">
                      <ul style={styles.list}>
                          <li style={styles.listItem}>
                              Services are provided “as is” without warranties.
                          </li>
                          <li style={styles.listItem}>
                              We do not guarantee uninterrupted or error-free service.
                          </li>
                          <li style={styles.listItem}>
                              Users assume risks associated with use.
                          </li>
                      </ul>
                  </Section>

                  <Section title="11. Limitation of Liability">
                      DataUp Gaming shall not be liable for direct, indirect, or
                      consequential damages resulting from platform use.
                  </Section>

                  <Section title="12. Indemnification">
                      You agree to indemnify DataUp Gaming against claims arising
                      from your use or violation of these terms.
                  </Section>

                  <Section title="13. Termination">
                      We may terminate or suspend accounts at our discretion.
                  </Section>

                  <Section title="14. Governing Law and Dispute Resolution">
                      These Terms are governed by the laws of your applicable jurisdiction.
                  </Section>

                  <Section title="15. Changes to Terms and Conditions">
                      Continued use of the platform constitutes acceptance of revised terms.
                  </Section>

                  <Section title="16. Contact Information">
                      <div style={styles.contactBox}>
                          Email:{" "}
                          <a
                              href="mailto:support@dataupgaming.com"
                              style={hover ? { ...styles.link, textDecoration: "underline" } : styles.link}
                              onMouseEnter={() => setHover(true)}
                              onMouseLeave={() => setHover(false)}
                          >
                              support@dataupgaming.com
                          </a>
                      </div>
                  </Section>

                  <p style={styles.footer}>
                      By using DataUp Gaming, you acknowledge that you have read,
                      understood, and agreed to these Terms and Conditions.
                  </p>
              </div>
          </div>
      </div></><SectionNine /></>
  );
}  

const Section: React.FC<{ title: string; children: React.ReactNode }> = ({
  title,
  children,
}) => (
  <section style={styles.section}>
    <h2 style={styles.sectionTitle}>{title}</h2>
    <div style={styles.paragraph}>{children}</div>
  </section>
);

export default Terms;

const styles: Record<string, React.CSSProperties> = {
  page: {
    minHeight: "100vh",
    backgroundColor: "#F7F8FA",
    padding: "56px 16px",
    color: "#101828",
    fontFamily:
      'ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Arial',
  },
  container: {
    maxWidth: 960,
    margin: "0 auto",
  },
  card: {
    backgroundColor: "#FFFFFF",
    borderRadius: 18,
    border: "1px solid #EAECF0",
    boxShadow: "0 14px 40px rgba(16, 24, 40, 0.08)",
    padding: "28px 22px",
  },
  header: {
    textAlign: "center",
    marginBottom: 26,
  },
  title: {
    fontSize: 36,
    fontWeight: 800,
    margin: "10px 0 6px",
  },
  updated: {
    fontSize: 13,
    color: "#667085",
    fontWeight: 600,
  },
  effective: {
    fontSize: 14,
    color: "#344054",
    marginTop: 6,
  },
  intro: {
    fontSize: 15.5,
    lineHeight: 1.75,
    color: "#344054",
    marginTop: 16,
  },
  section: {
    marginTop: 26,
  },
  sectionTitle: {
    fontSize: 20,
    fontWeight: 800,
    marginBottom: 10,
  },
  paragraph: {
    fontSize: 15.5,
    lineHeight: 1.75,
    marginBottom: 12,
    color: "#344054",
  },
  list: {
    paddingLeft: 22,
    marginBottom: 14,
  },
  listItem: {
    marginBottom: 8,
    fontSize: 15.5,
    lineHeight: 1.75,
    color: "#344054",
  },
  contactBox: {
    marginTop: 14,
    padding: 14,
    backgroundColor: "#E6F5FE",
    border: "1px solid #B7E2FA",
    borderRadius: 12,
  },
  link: {
    color: "#027EC2",
    fontWeight: 700,
    textDecoration: "none",
  },
  footer: {
    marginTop: 20,
    fontSize: 13,
    color: "#667085",
    textAlign: "center",
  },
};


